import React from 'react';
import { Box } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { radii } from '@/theme';
import { ActionButton, useModeTokens } from '@/common/components/ui';
import { useGoogleSignIn } from '@/common/auth/components/GoogleSignIn';
import { Headline } from './primitives';

/** Conversion actions use the live sign-in and release-download flows. */
export const LandingCta: React.FC<{ onDownload: () => void }> = ({
  onDownload,
}) => {
  const t = useModeTokens();
  const { signIn, isLoading, isConfigured } = useGoogleSignIn();

  return (
    <Box sx={{ padding: { xs: '0 20px 32px', md: '0 40px 40px' } }}>
      <Box
        className="lp-proof lp-gloss-panel lp-gloss-finale"
        sx={{
          borderRadius: `${radii['3xl']}px`,
          border: `1px solid ${alpha(t.colors.accentFill, 0.32)}`,
          background: t.surfaces.cardGradientSoft,
          boxShadow: t.shadows.panel,
          padding: { xs: '48px 20px', md: '80px 40px' },
          textAlign: 'center',
          backgroundImage: `radial-gradient(ellipse at 50% 130%, ${alpha(t.colors.accentFill, 0.2)}, transparent 70%)`,
        }}
      >
        <Headline min={36} max={64} sx={{ marginBottom: '20px' }}>
          The next version
          <br />
          <span className="lp-gradient-text">starts with you.</span>
        </Headline>
        <Box
          component="p"
          sx={{
            margin: '0 auto 26px',
            fontSize: '14.5px',
            lineHeight: 1.6,
            color: t.text.secondary,
            maxWidth: '48ch',
          }}
        >
          Bring one session. Save one checkpoint. Give your next idea room to
          happen.
        </Box>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            gap: 2,
            flexWrap: 'wrap',
          }}
        >
          {isConfigured && (
            <ActionButton
              className="lp-gloss-action"
              size="xl"
              onClick={signIn}
              disabled={isLoading}
              sx={{
                padding: '9px 18px',
                borderRadius: '6px',
                boxShadow: t.shadows.accentXl,
              }}
            >
              {isLoading ? 'Signing in…' : 'Get started with Google →'}
            </ActionButton>
          )}
          <ActionButton
            className="lp-gloss-action"
            variant="secondary"
            size="xl"
            onClick={onDownload}
          >
            Get the desktop app
          </ActionButton>
        </Box>
        <Box sx={{ mt: 2.5, fontSize: 12, color: t.text.muted }}>
          StudioVault is in beta. Your feedback helps shape what comes next.
        </Box>
      </Box>
    </Box>
  );
};

export default LandingCta;
